import CrudRequest from 'Arch/components/crud/CrudRequest';
import httpService from 'Arch/services/HttpService';

function report(path, payload) {
  return httpService.post(
    `/reports/reports/${path}`,
    payload,
  );
}

export default class UsersRequest extends CrudRequest {
  static baseUrl() {
    return '/account/users';
  }

  static getDocuments(params = {}) {
    return httpService.get('/account/documents/user-documents', {
      params,
    });
  }

  static solicit(payload = {}) {
    return report('users', payload);
  }

  static logout(userSystemId) {
    return httpService.post(
      `${this.baseUrl()}/${userSystemId}/logout`,
    );
  }

  static unlock(userSystemId) {
    return httpService.patch(
      `account/auth/unlock-login/${userSystemId}`,
    );
  }

  static balanceReport(payload) {
    return report('users-balance', payload);
  }

  static unlockRecoveryPass(userId) {
    return httpService.patch(
      `${this.baseUrl()}/recovery-attempts/${userId}`,
    );
  }
}
